import { FormEvent, useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  Lead,
  actions, // reset
} from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/shared/App';

import { getLeadStatusFromUrl, getLeadStatusUrl } from './helpers';

export interface LeadTableActionsHook {
  statuses: (Lead['status'] | '')[];
  activeStatus: Lead['status'] | '';
  onStatusChange: (...args: any[]) => void;
  onSourceChange: (...args: any[]) => void;
}

export default function useLeadTableActions(
  availableStatuses: (Lead['status'] | '')[],
): LeadTableActionsHook {
  const dispatch = useAppDispatch();
  const { push } = useHistory();
  const { pathname } = useLocation();
  const activeStatus = getLeadStatusFromUrl(pathname);
  const [source, setSource] = useState<Lead['source'] | undefined>();

  const statuses = availableStatuses.filter(
    (status) => status !== activeStatus,
  );

  const getParams = useCallback(
    (currentSource?: Lead['source'], currentStatus?: Lead['status'] | '') => {
      const params: { q?: string } = {};

      const statusFilter = currentStatus ? `status:${currentStatus}` : null;
      const sourceFilter = currentSource ? `source:${currentSource}` : null;

      params.q = [statusFilter, sourceFilter].filter(Boolean).join(',');

      return params;
    },
    [],
  );

  const onStatusChange = useCallback(
    (e: FormEvent<HTMLSelectElement>) => {
      const status = e.currentTarget.value as Lead['status'];

      push(getLeadStatusUrl(status));

      const extraParams = getParams(source, status);

      // dispatch(reset);

      dispatch(
        actions.getLeads({
          forceReload: true,
          params: {
            format: 'reduced',
            ...extraParams,
          },
        }),
      );
    },
    [source],
  );

  const onSourceChange = useCallback(
    (e: FormEvent<HTMLSelectElement>) => {
      const currentSource = e.currentTarget.value as Lead['source'];

      setSource(currentSource);

      const extraParams = getParams(currentSource, activeStatus);

      // dispatch(reset);

      dispatch(
        actions.getLeads({
          forceReload: true,
          params: {
            format: 'reduced',
            ...extraParams,
          },
        }),
      );
    },
    [activeStatus],
  );

  return {
    onStatusChange,
    statuses,
    activeStatus,
    onSourceChange,
  };
}
